const breadcrumbsMixin = {
  data() {
    return {};
  },
  methods: {
    /**
     * Data passed must be an array containing one or more objects, example:
     * [{parameter: ":worker_list_id", value: 1}]
     * parameter - name from the url we want to replace
     * value - replace with this value
     * @param data
     */
    updateBreadcrumbs(data) {
      let breadcrumbsCopy = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));

      for (const index in data) {
        if (data.hasOwnProperty(index)) {
          let parameter = data[index].parameter;
          let valueToAssign = data[index].value;

          breadcrumbsCopy.filter((el) => {
            if (el.url.includes(parameter)) {
              if (undefined === valueToAssign) {
                el.delete = true;
              } else {
                el.url = el.url.replace(parameter, valueToAssign);
              }
            }

          });
        }
      }
      this.$store.commit('UPDATE_BREADCRUMBS', breadcrumbsCopy.filter(item => !item.delete));
    },
  },
};
export default breadcrumbsMixin;
